import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppService } from '../../service/app.service';
import { AuthService } from '../../core/auth/auth.service';

@Component({
  selector: 'app-main-bar',
  templateUrl: './main-bar.component.html',
  styleUrls: ['./main-bar.component.scss']
})
export class MainBarComponent {
  title = environment.title || "Console";

  constructor(
    public authService: AuthService,
    public appService: AppService) {
  }

}
